import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import Quilleditor from "../../Quilleditor/Quilleditor";
import DatePicker from "../../DatePicker/datePicker";
import EditorInput from "../../Inputs/EditorInput";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";
import DateEdit from "../../DatePickerNew/DatePicker";
import Slider from "../../RcSlider/rcSlider";
import ProfileForm from "../../../hooks/editor/profileForm";
import ProfileImageModal from "../../../Components/Modals/ProfileImageModal";

function EducationItem(props) {
  const [t, i18n] = useTranslation("common");
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleDatePicker = (selected) => {
    setShowDatePicker(!showDatePicker);
  };

  const setValueDot = (value) => {
    props.setDotValue(value);
  };

  const handleImageChange = () => {
    setModalShow(true);
  };
  const onresumeHide = () => {
    setModalShow(false);
    setFileUploadError("");
  };

  const {
    fileUpload,
    resetImage,
    modalShow,
    setModalShow,
    profileImage,
    fileUploadError,
    setFileUploadError,
    disableSave,
    setDisableSave,
  } = ProfileForm(
    props.sectionId,
    props.resumeAllFields,
    props.setResumeFields,
    props.resumeUpdate
  );

  return (
    <>
      <div className=" col-md-12">
        <div className="row">
          <div className="col-md-12 mb-3 mr-2">
            {!props.showPopup && (
              <img
                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
                alt="trash"
                className="ml-1 delete_icon float-right"
                onClick={props.handleItemDelete}
              />
            )}
          </div>
          {/* {!props.showPopup &&
                    <div className="col-md-1">
                        <img
                        src="/images/acc-dropup.svg"
                        className="ml-2"
                        />
                    </div>
                    } */}
        </div>
      </div>
      <div className=" col-md-12">
        <div className="row">
          {props?.res?.showFields?.name && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label="Name"
                value={props.res.name}
                name="name"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.socialNetwork && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label="Social Network"
                value={props.res.socialNetwork}
                name="socialNetwork"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.userName && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label="UserName"
                value={props.res.userName}
                name="userName"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.referenceName && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label="Reference Name"
                value={props.res.referenceName}
                name="referenceName"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.referenceContact && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label="Reference Contact"
                value={props.res.referenceContact}
                name="referenceContact"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.title && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label="Title"
                value={props.res.title}
                name="title"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.authors && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label="Authors"
                value={props.res.authors}
                name="authors"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.image && (
            <div className="col-md-6 mb-3">
              <div onClick={(e) => handleImageChange(e)}>
                {props?.res?.image ? (
                  <>
                    <div
                      className="books-image"
                      style={{
                        backgroundImage: `url(${
                          props?.res?.image ? props?.res?.image : ""
                        })`,
                      }}
                    >
                      {/* <img className="w-100" src={props?.res?.image} /> */}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="books-image-empty">
                      <div className="plus-div-bookings">
                        <i
                          class="fa fa-plus-circle basic-suggestion-add-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          {props?.res?.showFields?.slider && (
            <>
              <div className="col-md-6 mb-3">
                <label>{t(`skills.level`)}</label>
                <div className="slide-center">
                  <Slider
                    skill
                    dots
                    index={props.index}
                    value={props.res.level}
                    sectionId={props.sectionId}
                    resumeHandler={props.resumeHandler}
                    languageHandler={props.languageHandler}
                    dotValue={setValueDot}
                    onBlur={props.resumeUpdate}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* {showDatePicker && showDatePicker && (
        <>
          <DateEdit
            dateHandler={props.dateHandler}
            index={props.index}
            response={props.res}
            showDatePicker={showDatePicker}
            setShowDatePicker={setShowDatePicker}
            isSelectedFrom={props.isSelectedFrom}
            sectionId={props.sectionId}
          />
        </>
      )} */}
      {modalShow && (
        <ProfileImageModal
          show={modalShow}
          fileUploadError={fileUploadError}
          onHide={onresumeHide}
          upload={(e) => {
            fileUpload(e, "books", props.index);
          }}
          disableSave={disableSave}
          setDisableSave={setDisableSave}
        />
      )}
    </>
  );
}

export default EducationItem;
